export function absoluteUrl(input: string) {
  if (input.startsWith('http')) return input;
  return `${process.env.REACT_APP_DRUPAL_BASE_URL}${input}`;
}
